import req from '@/libs/req'

const reqData = (data) => { return req.request('pinkCircle/getBusinessListForBack', data) }

const delRights = (data) => { return req.request('pinkCircle/delBusinessForBack', data) }

export default {
  reqData,
  delRights
}
